<script>
    // import {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user.js";
    import Alert from "../stores/alerts.js";
    import {PASSWORD_TIP} from "../lib/constants.js";
    import {setFocusTo} from "../lib/lib.js";
    import PasswordControl from "../components/controls/PasswordControl.svelte";
    import PageInfo from "../components/pages/PageInfo.svelte";

    let request = null;
    let errorTitle = null;
    let errorMessage = null;
    let memberId = null;
    let password = null;
    let confirmPassword = null;
    let success = false;

    const load = () => {
        const onSuccess = result => {
            memberId = result.object_id;
            setFocusTo('password');
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                errorTitle = "Not found";
                errorMessage = "Could not find your request!";
                return;
            }

            if (err.code === 'request_expired') {
                errorTitle = "Invalid request";
                errorMessage = "This request has been expired!";
                return;
            }

            if (err.code === 'request_completed') {
                errorTitle = "Invalid request";
                errorMessage = "This request has been completed!";
                return;
            }

            errorMessage = "there was an error with your request!";
        };

        R.handle(R.actionRequest.confirm, request, onSuccess, onFailure, LOADER.PAGE);
    }

    const submit = () => {
        const onSuccess = result => {
            success = true;
            user.setUser(result);
            Alert.alert("Member account", "Your account password change is complete.\nYou are now signed in to your account.", () => {
                window.location.replace('/');
            });
            // router.go('/')();
        }

        const onFailure = err => {
            if (err.code === 'password_field_invalid') {
                Alert.warning("Invalid password", PASSWORD_TIP, () => setFocusTo('password'));
                confirmPassword = null;
                setFocusTo('password');
                return;
            }

            errorMessage = err.message;
        }

        if (password !== confirmPassword) {
            Alert.warning("Change account password", "Your password confirmation is wrong!", () => {
                confirmPassword = null;
                setFocusTo('confirmPassword');
            });
            return;
        }

        let data = {
            id: memberId,
            request,
            password
        }

        R.handle(R.member.setPassword, data, onSuccess, onFailure, LOADER.POPUP);
    }

    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('request')) {
        request = searchParams.get('request');
    }

    if (!$user.token) {
        load();
    }
</script>

<div class="page-overlay">
    <div class="page-wrapper">
        <div class="panel-simple panel-pad reset-password box-shadow rounded">
            <div class="form-logo mb-4">
                <img src="/assets/images/logo-rect-green.png" alt="logo">
            </div>
            <h2 class="line-height-1">Reset Account Password</h2>

            {#if !errorMessage}
                {#if $user.token && !success}
                    <PageInfo type="info" icon="user" message="you are already signed in to your account" internal/>
                    <div class="text-center">
                        <a href="/" class="btn-link">Go to home</a>
                    </div>
                {:else if memberId}
                    <form on:submit|preventDefault|stopPropagation="{ submit }">
                        <p class="text-gray">
                            { PASSWORD_TIP }
                        </p>
                        <div class="form-group">
                            <label>Type your new password</label>
                            <PasswordControl id="password" bind:value="{ password }"/>
                        </div>
                        <div class="form-group">
                            <label>Retype your new password</label>
                            <PasswordControl id="confirmPassword" bind:value="{ confirmPassword }"/>
                        </div>
                        <button class="btn btn-primary btn-block rounded">Update password</button>
                    </form>
                {/if}
            {:else}
                <PageInfo title="{ errorTitle }" message="{ errorMessage }" internal/>
            {/if}
        </div>
    </div>
</div>

<style>
    .page-wrapper {
        width: 95%;
        max-width: 400px;
        height: 100%;
        margin: auto;
        position: relative;
    }

    .reset-password {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
</style>